import NumberInput from "./numberInput.element";
import {CSSProperties} from "react";
import {Tooltip} from "@mui/material";
import {FieldConstraint} from "../models/attributeManifest.model";
import {useFieldDoc} from "./useFieldDoc";

interface NumberInputLabelProps {
    // Optional: when omitted, the label falls back to the manifest field's Label
    // (from [FieldDoc]) so a field's presentation can live entirely in the Client
    // model. An explicit title always wins.
    title?: string;
    value: number;
    step?: string;
    displayDecimals?: number;
    tooltip?: string;
    style?: CSSProperties;
    inputStyle?: CSSProperties;
    // Constraint source. Either resolved by manifest data-path key (`field`, e.g.
    // "unit.properties.attack") or passed directly (`constraint`, e.g. a metadata
    // param's Min/Max). The input clamps to it on commit. Both optional — omit for
    // an unconstrained field.
    field?: string;
    constraint?: FieldConstraint | null;
    onChange(value: number): void;
}

function NumberInputLabel(props: NumberInputLabelProps) {
    const {constraint, label, tip} = useFieldDoc({
        field: props.field, title: props.title, tooltip: props.tooltip, constraint: props.constraint,
    });

    return (
        <div className={'layout horizontal stretch gap flex-grow'}
             style={{...{alignItems: 'center', gap: 10}, ...props.style}}>
            <div className={'layout horizontal center gap'}>
                {tip
                    ? <Tooltip title={tip} arrow disableInteractive>
                        <p className={'flex-grow'} style={{cursor: 'help'}}>{label}</p>
                    </Tooltip>
                    : <p className={'flex-grow'}>{label}</p>}
            </div>
            <NumberInput value={props.value} step={props.step} displayDecimals={props.displayDecimals} style={props.inputStyle} constraint={constraint} onChange={props.onChange}/>
        </div>
    )
}

export default NumberInputLabel;
